import { render, staticRenderFns } from "./doctor-card.vue?vue&type=template&id=82f5d492&scoped=true&"
import script from "./doctor-card.vue?vue&type=script&lang=js&"
export * from "./doctor-card.vue?vue&type=script&lang=js&"
import style0 from "./doctor-card.vue?vue&type=style&index=0&id=82f5d492&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f5d492",
  null
  
)

export default component.exports